import { TenantAlertPackage, TenantAlertReport } from '$/lib/tenantAlert/TenantAlertTypes';

import Permissions                           from '$/entities/lib/Permissions';
import { CommonEntity, ChildEntity, Column } from '$/entities/BaseEntity';
import { CreditReport }                      from '$/entities/tenantScreening/CreditReport';
import { ChargeableProp }                    from '$/entities/Package';

@CommonEntity() @ChildEntity()
export class TenantAlertCreditCheck extends CreditReport {

	report: TenantAlertReport = null;

	@Column()
	@Permissions({ write : Permissions.ifNotNew('insufficient permissions') })
	externalPackage: TenantAlertPackage;

	constructor(externalPackage?: TenantAlertPackage) {
		super();
		this.externalPackage = externalPackage;
	}

	get chargeable() {
		return this.externalPackage === TenantAlertPackage.Pro ? ChargeableProp.CreditChecksPro : ChargeableProp.CreditChecks;
	}

}
